<template>
    <div class="Match">

        <div class="Match__head" v-if="mode != 'draws'">

            {{roundDisplay(match.detail.rnd)}} &bull; {{type}} &bull; {{isQualifying()}}

        </div>

        <div class="Match__body">

            <div class="Match__line" :class="{ 'Match__line--winner': winner(match.detail.winner , 'a') }">

                <div class="Match__player__holder">

                    <div class="Match__player">

                        <img class="small-flag" :src="getFlagPath(match.detail.cA)"
                             :alt="match.detail.cA || ''">

                        <span class="Match__player__fn">{{match.detail.nAF}}</span><span class="Match__player__i">{{initial(match.detail.nAF)}}</span>&nbsp;<span
                            class="Match__player__ln">{{match.detail.nAL}}</span>
                        <span class="Match__player__seed"
                              v-if="match.detail.seedA">[{{match.detail.seedA}}]</span>
                        <span class="Match__player__seed"
                              v-if="showType( 'q', match.detail.idA )">[Q]</span>
                        <span class="Match__player__seed"
                              v-if="showType( 'wc', match.detail.idA )">[WC]</span>

                    </div>

                    <div class="Match__player" v-if="forceDoubeCheck()">

                        <img class="small-flag" :src="getFlagPath(match.detail.cA2)"
                             :alt="match.detail.cA2 || ''">

                        <span class="Match__player__fn">{{match.detail.nA2F}}</span><span class="Match__player__i">{{initial(match.detail.nA2F)}}</span>&nbsp;<span
                            class="Match__player__ln">{{match.detail.nA2L}}</span>
                        <span class="Match__player__seed"
                              v-if="match.detail.seedA">[{{match.detail.seedA}}]</span>
                        <span class="Match__player__seed"
                              v-if="showType( 'q', match.detail.idA2 )">[Q]</span>
                        <span class="Match__player__seed"
                              v-if="showType( 'wc', match.detail.idA2 )">[WC]</span>

                    </div>

                </div>

                <div v-if="match.detail.serve == '0' || match.detail.serve == '2'"
                     class="Match__serve" v-html="ico_ball">
                </div>

                <div v-if="winner(match.detail.winner , 'a')"
                     class="Match__winner" v-html="ico_winner"></div>

                <div class="Match__set">

                    <ul>
                        <li class="Match__set__pt" v-if="match.detail.ptA">{{match.detail.ptA}}</li>
                        <li v-if="match.detail">
                            {{match.detail.s1A}}<sup v-if="match.detail.s1A < match.detail.s1B">{{match.detail.tb1}}</sup>
                        </li>
                        <li v-if="match.detail.s2A">
                            {{match.detail.s2A}}<sup v-if="match.detail.s2A < match.detail.s2B">{{match.detail.tb2}}</sup>
                        </li>
                        <li v-if="match.detail.s3A">
                            {{match.detail.s3A}}<sup v-if="match.detail.s3A < match.detail.s3B">{{match.detail.tb3}}</sup>
                        </li>
                    </ul>

                </div>

            </div>

            <div class="Match__line" :class="{ 'Match__line--winner': winner(match.detail.winner , 'b') }">

                <div class="Match__player__holder">

                    <div class="Match__player">

                        <img class="small-flag" :src="getFlagPath(match.detail.cB)"
                             :alt="match.detail.cB || ''">

                        <span class="Match__player__fn">{{match.detail.nBF}}</span><span class="Match__player__i">{{initial(match.detail.nBF)}}</span>&nbsp;<span
                            class="Match__player__ln">{{match.detail.nBL}}</span>
                        <span class="Match__player__seed"
                              v-if="match.detail.seedB">[{{match.detail.seedB}}]</span>
                        <span class="Match__player__seed"
                              v-if="showType( 'q', match.detail.idB )">[Q]</span>
                        <span class="Match__player__seed"
                              v-if="showType( 'wc', match.detail.idB )">[WC]</span>

                    </div>

                    <div class="Match__player" v-if="forceDoubeCheck()">

                        <img class="small-flag" :src="getFlagPath(match.detail.cB2)"
                             :alt="match.detail.cB2 || ''">

                        <span class="Match__player__fn">{{match.detail.nB2F}}</span><span class="Match__player__i">{{initial(match.detail.nB2F)}}</span>&nbsp;<span
                            class="Match__player__ln">{{match.detail.nB2L}}</span>
                        <span class="Match__player__seed"
                              v-if="match.detail.seedB">[{{match.detail.seedB}}]</span>
                        <span class="Match__player__seed"
                              v-if="showType( 'q', match.detail.idB2 )">[Q]</span>
                        <span class="Match__player__seed"
                              v-if="showType( 'wc', match.detail.idB2 )">[WC]</span>

                    </div>

                </div>

                <div v-if="match.detail.serve == '1' || match.detail.serve == '3'"
                     class="Match__serve" v-html="ico_ball">
                </div>

                <div v-if="winner(match.detail.winner , 'b')"
                     class="Match__winner" v-html="ico_winner"></div>

                <div class="Match__set">

                    <ul>

                        <li class="Match__set__pt" v-if="match.detail.ptB">{{match.detail.ptB}}</li>
                        <li v-if="match.detail.s1B">
                            {{match.detail.s1B}}<sup v-if="match.detail.s1A > match.detail.s1B">{{match.detail.tb1}}</sup>
                        </li>
                        <li v-if="match.detail.s2B">
                            {{match.detail.s2B}}<sup v-if="match.detail.s2A > match.detail.s2B">{{match.detail.tb2}}</sup>
                        </li>
                        <li v-if="match.detail.s3B">
                            {{match.detail.s3B}}<sup v-if="match.detail.s3A > match.detail.s3B">{{match.detail.tb3}}</sup>
                        </li>

                    </ul>

                </div>

            </div>

            <div class="Match__meta">

                <div class="Match__time">
                    <span v-html="ico_clock"></span>
                    {{matchTime(match.detail.mt)}}
                </div>

                <div class="Match__msg" v-if="mode == 'live' && messageFormat(match.detail)">
                    <span v-html="messageFormat(match.detail)">
                    </span>
                </div>

                <a :href="detail + '?match=' + match.id" class="Match__link">
                    <!-- <span v-html="ico_pointer_right"></span> -->
                    Match&nbsp;stats
                </a>

            </div>

        </div>
    </div>
</template>

<script>
    export default {
        props: ['match', 'flagPath', 'detail', 'mode', 'type'],
        data() {
            return {
                ico_winner : window.ico_tick,
                ico_ball   : window.ico_ball,
                ico_clock  : window.ico_clock,
                to_display : this.match,
            }
        },
        methods: {
            winner(winner, team) {
                if (team == 'a' && (winner == '2' || winner == '4' || winner == '6')) {
                    return true
                }
                if(team == 'a' && winner != '' && (winner == this.match.detail.idA  )) {
                    return true
                }

                if (team == 'b' && (winner == '3' || winner == '5' || winner == '7')) {
                    return true
                }
                if(team == 'b' && winner != '' && (winner== this.match.detail.idB )) {
                    return true
                }

                return false
            },
            matchTime(time) {
                if (time.length < 6) {
                    return time + ':00'
                }

                return time
            },
            courtDisplay(courtId) {

                let courts = window.court_stadium

                courts = courts.filter(function(court) {
                    return court.court_id == courtId
                })

                if ( courts.length > 0 ) {
                    return courts[0].stadium_name
                }

                return courtId

            },
            roundDisplay(round) {
                if (round == '1' || round == 'R32' || round == 'First Round')
                    return 'Round 1'
                else if (round == '2' || round == 'R16' || round == 'Second Round')
                    return 'Round 2'
                else if (round == '3')
                    return 'Round 3'

                if (this.type == 'wta') {
                    if (round == 'Q')
                        return 'Quarterfinals'
                    else if (round == 'S')
                        return 'Semifinals'
                    else if (round == 'F')
                        return 'Final'
                } else {
                    if (round == '5')
                        return 'Quarterfinals'
                    else if (round == '6')
                        return 'Semifinals'
                    else if (round == '7')
                        return 'Final'
                }

                if ( round == 'Q1' || round == 'R1' )
                    return 'Round 1'
                else if ( round == 'Q2' || round == 'R2' || round == "Q4" )
                    return 'Round 2'

                return round;
            },
            initial(name) {
                return `${name.charAt(0)}.`
            },
            isQualifying() {
                if ( this.to_display.detail.isQuals == '1' )
                    return 'qualifying'
                else
                    return 'main draw'
            },
            messageFormat(detail) {

                if (detail.msg == '') {
                    return ''
                }

                let messages = detail.msg.match(/{(.*?)}/)
                let messageParts = messages[0].slice(1, -1).split('|')

                if (messageParts[0] == '1') {
                    return 'Match point'
                }

                if (messageParts[0] == '2') {
                    return `${messageParts[1]} match points`
                }

                if (messageParts[0] == '3') {
                    return 'Break point'
                }

                if (messageParts[0] == '4') {
                    return `${messageParts[1]} break points`
                }

                if (messageParts[0] == '5') {
                    return 'Set point'
                }

                if (messageParts[0] == '6') {
                    return `${messageParts[1]} set points`
                }

                if (messageParts[0] == '7') {
                    return '2nd serve'
                }

                if (messageParts[0] == '8') {
                    return `Double fault #${messageParts[1]} for ${messageParts[2]}`
                }

                if (messageParts[0] == '9') {
                    return `Ace  - ${messageParts[1]} for ${messageParts[2]}`
                }
                if (messageParts[0] == '10') {
                    return `Ace on 2nd serve – ace #${messageParts[1]} for ${messageParts[2]}`
                }

                if (messageParts[0] == '11') {
                    return ''
                    return `Winner: ${messageParts[1]}`
                }

                if (messageParts[0] == '12') {
                    return ''
                    return `Winners ${messageParts[1]}`
                }

                if (messageParts[0] == '13') {
                    return `Double fault ${messageParts[1]} - #${messageParts[2]} for the team`
                }

                if (messageParts[0] == '14') {
                    return `Ace ${messageParts[1]} - #${messageParts[2]} for the team`
                }

                if (messageParts[0] == '15') {
                    return `Ace on 2nd serve ${messageParts[1]} - #${messageParts[2]} for the team`
                }

                if (messageParts[0] == '16') {
                    return 'Match suspended – rain'
                }

                if (messageParts[0] == '17') {
                    return 'Match suspended – darkness'
                }

                if (messageParts[0] == '18') {
                    return 'Match suspended – heat'
                }

                if (messageParts[0] == '19') {
                    return 'Match suspended'
                }

                if (messageParts[0] == '20') {
                    return 'by retirement'
                }

                if (messageParts[0] == '21') {
                    return `Point penalty against ${messageParts[1]}`
                }

                if (messageParts[0] == '22') {
                    return `Game penalty against ${messageParts[1]}`
                }

                if (messageParts[0] == '23') {
                    return `Time penalty against ${messageParts[1]}`
                }

                if (messageParts[0] == '24') {
                    return 'by default'
                }

                if (messageParts[0] == '25') {
                    return 'Game point'
                }

                if (messageParts[0] == '26') {
                    return `${messageParts[1]} game points`
                }

                if (messageParts[0] == '27') {
                    return 'Foot fault – 2nd serve'
                }

                if (messageParts[0] == '28') {
                    return `Foot fault – Double fault #${messageParts[1]} for ${messageParts[2]}`
                }

                if (messageParts[0] == '29') {
                    return `Foot fault – Double fault ${messageParts[1]} - #${messageParts[2]} for the team`
                }

                if (messageParts[0] == '30') {
                    return 'Let'
                }

                return ''

            },
            findPlayerById( playerId ) {
                if ( playerId == '' )
                    return false

                let found = window.all_players.filter(player => player.player_id == playerId)

                if (found.length >= 1)
                    return found[0]

                return false
            },
            forceDoubeCheck(){
               if (this.match.detail.isDoubles == 1){
                   return true
               }else if(this.match.detail.isDoubles == '' && this.match.id.substring(0, 2) == "MD"){
                   return true
               }else{
                   return false
               }
            },
            showType( type, playerId ) {
                let player = this.findPlayerById( playerId )

                if ( type == 'wc' && player.iswildcard == '1' )
                    return true
                else if ( type == 'q' && player.isqualifier == '1' )
                    return true

                return false;
            },
            getFlagPath(countryCode) {
                if (!countryCode) return this.flagPath + '---.svg';
                return this.flagPath + countryCode.toLowerCase() + '.svg';
            }
        }
    }
</script>
